
import React from 'react';
import dateformat from 'dateformat';

import _ from 'lodash';
import cx from 'classnames';
import styles from './styles.module.scss';
import UserAvatar from '../userAvatar';
import Truncate from 'src/components/truncate';
import GenerateQRCode from 'src/components/generateQRCode';

interface ActionNeededProps {
  name: string;
  icon: string;
  lastUpdatedDate?: Date;
  isIntegrated: boolean;
  handleClick?: () => void;
  classnames?: string;
  actionItem?: React.ReactNode | undefined;
}

export const ActionNeeded = ({ name, icon, lastUpdatedDate, isIntegrated, handleClick, classnames, actionItem}: ActionNeededProps) => {
  return (
    <div className={cx(styles.actionNeeded, classnames)}>
      <p className={styles.headerText}><i className='paperflite-danger' /> {name} </p>
      { actionItem ?? 
      <div className={styles.subText}>
        <p className={styles.lastUpdated}> {isIntegrated ? `Last updated ${dateformat(lastUpdatedDate, 'dd mmm yyyy')}` : "Authentication pending"}</p>
        <p className={cx(styles.alignCenter, styles.primaryColor)} onClick={handleClick && handleClick}> <i className='paperflite-right-arrow' /> {isIntegrated ? "reauthenticate" : "authenticate"} </p>
      </div> }
      <img src={icon} alt="icon" className={styles.icon} />
    </div>
  )
}


export const RecentActivity = ({event}) => {
  return (
    <div className={styles.recentActivity}>
      <UserAvatar src={_.get(event,"user.icon.full")} width='2rem' height='2rem' />
      <div className={styles.text}> {event?.message} </div>
      <img className={styles.medium} src={_.get(event,"productCapabilityResponse.icon")} alt="icon" />
    </div>
  )
}


export const VersionUpdate = ({version, qrLink, deviceName}: {version: string, qrLink: string, deviceName: string}) => {
  return (

  <div className={styles.newVersion}>
      <p className={styles.subText}>Update your {deviceName} to version {version} for the latest features.</p>
      <p className={styles.greySubText}>latest version {version}</p>

      <div className={styles.qrCode}>
        <GenerateQRCode value={qrLink}/>
        <p>Scan to download for <br/> {deviceName} devices.</p>
      </div>
  </div>
  )
}

interface UserListCardProps {
  id: string;
  name: string;
  email: string;
  role?: string;
  icon?: string;
  isSelected: boolean;
  handleSelect: (id: string) => void;
}

export const UserListCard = ({ id, name, email, role, icon, isSelected, handleSelect }: UserListCardProps) => {

  return (
    <div className={cx(styles.userItem, styles.alignCenter)}>
      <UserAvatar width={"2.5rem"} height={"2.5rem"} src={icon} />
      <div className={styles.userDetails}>
        <p className={cx(styles.alignCenter, styles.name)}>
          <span className={cx(styles.alignCenter, styles.name)}>
            <Truncate tooltipText={name} width={200}>{name}</Truncate>
          </span>
          {role && <span className={styles.role}> {role} </span>}
        </p>
        <p>
          <span className={styles.email}>{email} </span>
        </p>
      </div>
      <span className={styles.alignCenter}>
        <i onClick={() => handleSelect(id)} className={cx(isSelected ? "fa-solid fa-check-circle" : "paperflite-radio-button-unselected", {
          [styles.selected]: isSelected,
        })} />
      </span>
    </div>
  )
}